import { useContext } from "react";
import { PrintIcon } from "components/SVGs";
import { FireBaseContext } from "contexts/FireBase";
import { useAppDispatch, useAppSelector } from "app/hooks";
import {
  printingSet,
  selectFormativeData,
  selectProgressData,
  selectReportType,
} from "features/Reports";

function PrintReport() {
  const dispatch = useAppDispatch();
  const reportType = useAppSelector(selectReportType);
  const progressData = useAppSelector(selectProgressData);
  const formativeData = useAppSelector(selectFormativeData);
  const { logEvent } = useContext(FireBaseContext);

  const isNotDisable =
    (progressData && Object.keys(progressData).length) ||
    (formativeData && Object.keys(formativeData).length);

  const clickHandler = () => {
    if (isNotDisable) {
      logEvent("ClickOnPrintReport", { Source: reportType });
      dispatch(printingSet(true));
      setTimeout(() => {
        window.print();
      }, 400);
      setTimeout(() => {
        dispatch(printingSet(false));
      }, 2000);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: isNotDisable ? "pointer" : "default",
      }}
      onClick={clickHandler}
    >
      <PrintIcon
        sx={{
          color: isNotDisable ? "rgb(77, 191, 241)" : "rgb(77, 191, 241, 0.3)",
        }}
      />
    </div>
  );
}

export default PrintReport;
